var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconV2Startdate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.3335C0 1.78121 0.447715 1.3335 1 1.3335H13.6667C14.219 1.3335 14.6667 1.78121 14.6667 2.3335V5.49299C14.6667 5.67709 14.5174 5.82633 14.3333 5.82633C14.1492 5.82633 14 5.67709 14 5.49299V2.3335C14 2.1494 13.8508 2.00016 13.6667 2.00016H1C0.815905 2.00016 0.666667 2.1494 0.666667 2.3335V13.6668C0.666667 13.8509 0.815905 14.0002 1 14.0002H5.85965C6.04374 14.0002 6.19298 14.1494 6.19298 14.3335C6.19298 14.5176 6.04374 14.6668 5.85965 14.6668H1C0.447716 14.6668 0 14.2191 0 13.6668V2.3335Z",
    fill: "#27323C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6667 5.33317H0V4.6665H14.6667V5.33317Z",
    fill: "#27323C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 -1.30811e-08C4.85076 -5.85661e-09 5 0.149238 5 0.333333L5 3C5 3.18409 4.85076 3.33333 4.66667 3.33333C4.48257 3.33333 4.33333 3.18409 4.33333 3L4.33333 0.333333C4.33333 0.149238 4.48257 -2.03056e-08 4.66667 -1.30811e-08Z",
    fill: "#27323C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99998 -1.30811e-08C10.1841 -5.85661e-09 10.3333 0.149238 10.3333 0.333333L10.3333 3C10.3333 3.18409 10.1841 3.33333 9.99998 3.33333C9.81588 3.33333 9.66665 3.18409 9.66665 3L9.66665 0.333333C9.66665 0.149238 9.81588 -2.03056e-08 9.99998 -1.30811e-08Z",
    fill: "#27323C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 7.66667C9.38291 7.66667 7.66667 9.38291 7.66667 11.5C7.66667 13.6171 9.38291 15.3333 11.5 15.3333C13.6171 15.3333 15.3333 13.6171 15.3333 11.5C15.3333 9.38291 13.6171 7.66667 11.5 7.66667ZM7 11.5C7 9.01472 9.01472 7 11.5 7C13.9853 7 16 9.01472 16 11.5C16 13.9853 13.9853 16 11.5 16C9.01472 16 7 13.9853 7 11.5Z",
    fill: "#27323C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.927 9.99851C14.0572 10.1287 14.0572 10.3397 13.927 10.4699L11.0061 13.3908L9.42783 11.8125C9.29766 11.6823 9.29766 11.4713 9.42783 11.3411C9.55801 11.2109 9.76906 11.2109 9.89924 11.3411L11.0061 12.448L13.4556 9.99851C13.5858 9.86834 13.7968 9.86834 13.927 9.99851Z",
    fill: "#27323C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconV2Startdate);
export default __webpack_public_path__ + "static/media/icon-v2_start date.af18e454d7768c7770af4bab3ea1a49f.svg";
export { ForwardRef as ReactComponent };